// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles */
.project {
    margin-top: 50px;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
}

.project .table {
    flex: 4 1;
    margin-left: 0;
    width: 100%;
}

/* Card styles */
.cardBox {
    background-color: #313844;
    border-radius: 5px;
    padding: 20px;
    width: 100%;
    box-sizing: border-box;
}

/* Table styles */
.tableBox {
    margin-top: 20px;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.light .tableContainer {
    background-color: #fff !important;
}

.tableContainer {
    max-height: 400px;
    overflow-y: auto;
    width: 100%;
    display: block;
    position: relative;
}

/* DatePicker and button styles */
.datePickerBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    gap: 10px;
    width: 100%;
    flex-wrap: wrap;
}

.datePicker::placeholder {
    color: black;
    opacity: 0.5;
}

.leftSection {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
    flex: 1 1;
    min-width: 0;
}

.rightSection {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: flex-end;
    flex: 1 1;
    min-width: 0;
}

.datePicker {
    padding: 8px 12px;
    border-radius: 4px;
    border: 1px solid #ccc;
    flex: 1 1;
    background-color: #ffffff;
    color: #000;
    min-width: 150px;
    box-sizing: border-box;
    height: 40px;
}

.datePickerBox .MuiButton-root {
    flex-shrink: 0;
    white-space: nowrap;
    margin: 2px 0;
    padding: 8px 12px;
    min-width: auto;
}

.filter-button, .action-button {
    height: 40px;
}

/* Loading overlay */
.loadingOverlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 1;
}

/* Table cell adjustments */
.MuiTableCell-root {
    padding: 8px 12px !important;
    word-break: keep-all;
}

/* Print styles */
@media print {
    body * {
        visibility: hidden;
    }

    .print-content,
    .print-content * {
        visibility: visible;
    }

    .print-content {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
    }

    .no-print {
        display: none;
    }
}

/* Responsive styles */
@media only screen and (max-width: 768px) {
    .project {
        flex-direction: column;
        margin-top: 20px;
        padding: 0 10px;
    }

    .project .table {
        margin-top: 20px;
    }

    .cardBox {
        padding: 15px;
    }

    .datePickerBox {
        flex-direction: column;
        gap: 10px;
    }

    .leftSection,
    .rightSection {
        width: 100%;
        justify-content: space-between;
    }

    .datePicker {
        width: calc(50% - 5px);
        min-width: 0;
    }

    .tableContainer {
        max-height: none;
    }

    .MuiTable-root {
        display: block;
        width: 100%;
        overflow-x: auto;
    }

    .MuiTableCell-root {
        padding: 6px 8px !important;
        font-size: 13px !important;
    }
}

@media only screen and (max-width: 480px) {
    .project {
        padding: 0 5px;
    }

    .leftSection,
    .rightSection {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
    }

    .datePicker {
        width: 100%;
    }

    .datePickerBox .MuiButton-root {
        width: 100%;
    }

    .MuiTableCell-root {
        padding: 6px !important;
        font-size: 12px !important;
    }

    .tableContainer {
        overflow-x: scroll;
    }
}

/* Very small screens */
@media only screen and (max-width: 360px) {
    .MuiTableCell-root {
        padding: 4px 6px !important;
        font-size: 11px !important;
    }

    .datePicker {
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/DataTable.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,cAAc;IACd,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,sBAAsB;AAC1B;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,SAAO;IACP,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,UAAU;AACd;;AAEA,2BAA2B;AAC3B;IACI,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA,iBAAiB;AACjB;IACI;QACI,kBAAkB;IACtB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;;QAEI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;;QAEI,sBAAsB;QACtB,oBAAoB;QACpB,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,uBAAuB;AACvB;IACI;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Base styles */\n.project {\n    margin-top: 50px;\n    display: flex;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 0 15px;\n}\n\n.project .table {\n    flex: 4;\n    margin-left: 0;\n    width: 100%;\n}\n\n/* Card styles */\n.cardBox {\n    background-color: #313844;\n    border-radius: 5px;\n    padding: 20px;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* Table styles */\n.tableBox {\n    margin-top: 20px;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n}\n\n.light .tableContainer {\n    background-color: #fff !important;\n}\n\n.tableContainer {\n    max-height: 400px;\n    overflow-y: auto;\n    width: 100%;\n    display: block;\n    position: relative;\n}\n\n/* DatePicker and button styles */\n.datePickerBox {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    gap: 10px;\n    width: 100%;\n    flex-wrap: wrap;\n}\n\n.datePicker::placeholder {\n    color: black;\n    opacity: 0.5;\n}\n\n.leftSection {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    flex-wrap: wrap;\n    flex: 1;\n    min-width: 0;\n}\n\n.rightSection {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    flex: 1;\n    min-width: 0;\n}\n\n.datePicker {\n    padding: 8px 12px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    flex: 1;\n    background-color: #ffffff;\n    color: #000;\n    min-width: 150px;\n    box-sizing: border-box;\n    height: 40px;\n}\n\n.datePickerBox .MuiButton-root {\n    flex-shrink: 0;\n    white-space: nowrap;\n    margin: 2px 0;\n    padding: 8px 12px;\n    min-width: auto;\n}\n\n.filter-button, .action-button {\n    height: 40px;\n}\n\n/* Loading overlay */\n.loadingOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(255, 255, 255, 0.7);\n    z-index: 1;\n}\n\n/* Table cell adjustments */\n.MuiTableCell-root {\n    padding: 8px 12px !important;\n    word-break: keep-all;\n}\n\n/* Print styles */\n@media print {\n    body * {\n        visibility: hidden;\n    }\n\n    .print-content,\n    .print-content * {\n        visibility: visible;\n    }\n\n    .print-content {\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 100%;\n    }\n\n    .no-print {\n        display: none;\n    }\n}\n\n/* Responsive styles */\n@media only screen and (max-width: 768px) {\n    .project {\n        flex-direction: column;\n        margin-top: 20px;\n        padding: 0 10px;\n    }\n\n    .project .table {\n        margin-top: 20px;\n    }\n\n    .cardBox {\n        padding: 15px;\n    }\n\n    .datePickerBox {\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .leftSection,\n    .rightSection {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .datePicker {\n        width: calc(50% - 5px);\n        min-width: 0;\n    }\n\n    .tableContainer {\n        max-height: none;\n    }\n\n    .MuiTable-root {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n    }\n\n    .MuiTableCell-root {\n        padding: 6px 8px !important;\n        font-size: 13px !important;\n    }\n}\n\n@media only screen and (max-width: 480px) {\n    .project {\n        padding: 0 5px;\n    }\n\n    .leftSection,\n    .rightSection {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 8px;\n    }\n\n    .datePicker {\n        width: 100%;\n    }\n\n    .datePickerBox .MuiButton-root {\n        width: 100%;\n    }\n\n    .MuiTableCell-root {\n        padding: 6px !important;\n        font-size: 12px !important;\n    }\n\n    .tableContainer {\n        overflow-x: scroll;\n    }\n}\n\n/* Very small screens */\n@media only screen and (max-width: 360px) {\n    .MuiTableCell-root {\n        padding: 4px 6px !important;\n        font-size: 11px !important;\n    }\n\n    .datePicker {\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
